import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'hooks/use-redux'
import { revokeShare } from '@disco/state-management/reducers/forms/channel-share'
import ModalDialog from 'components/ui/modal-dialog'

const ChannelShareRevocation = () => {
  const { channelId } = useParams<{ channelId: string }>()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const returnToShareDialog = () =>
    navigate(`/explorer/channels/${channelId}/share`)

  const onConfirm = async () => {
    try {
      await dispatch(revokeShare(parseInt(channelId)))
      returnToShareDialog()
    } catch (e) {}
  }

  return (
    <ModalDialog
      title="Disable share link"
      primaryAction={{
        caption: 'Confirm',
        onClick: onConfirm,
      }}
      status="danger"
      onCancel={returnToShareDialog}
    >
      Are you sure you want to permanently disable this share link?
    </ModalDialog>
  )
}

export default ChannelShareRevocation
